import {
  finiteLocaleNumber,
  formatLocaleDecimalMax2,
} from "./locale_decimal_max_2";

/** The customer-visible formatter for inventory matrix values. */
export const formatInventoryMatrixDisplayValue = (
  value: unknown,
  measureName: string | undefined,
): string => {
  if (value == null || value === "") return "";
  const numeric = finiteLocaleNumber(value);
  if (numeric === undefined) return String(value);
  const measure = (measureName ?? "").toLowerCase();
  if (
    measure.includes("in stock rate") ||
    measure.includes("pct ordered") ||
    measure.includes("forecast_accuracy") ||
    measure.includes("forecast_bias")
  ) {
    return `${(numeric * 100).toFixed(1)}%`;
  }
  if (
    measure.includes("weeks of supply") ||
    measure.includes("months of supply") ||
    measure.includes("days of supply")
  ) {
    return numeric.toFixed(1);
  }
  return formatLocaleDecimalMax2(numeric, "en-US") ?? String(value);
};
